import React from 'react';
import { Button } from '../ui/button';
import { Eye, EyeOff } from 'lucide-react';
import { useStealthMode } from './StealthModeProvider';
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from '../ui/tooltip';

interface StealthModeToggleProps {
  showLabel?: boolean;
  size?: 'sm' | 'default' | 'lg';
}

export function StealthModeToggle({ showLabel = false, size = 'default' }: StealthModeToggleProps) {
  const { isStealthMode, toggleStealthMode, showValueTemporarily } = useStealthMode();

  const handleClick = () => {
    toggleStealthMode();
  };

  const handleTemporaryShow = (e: React.MouseEvent) => {
    e.stopPropagation();
    if (isStealthMode) {
      showValueTemporarily(5000);
    }
  };

  return (
    <TooltipProvider>
      <Tooltip>
        <TooltipTrigger asChild>
          <Button
            variant={isStealthMode ? 'default' : 'outline'}
            size={size}
            onClick={handleClick}
            onDoubleClick={handleTemporaryShow}
            className={`transition-all ${
              isStealthMode
                ? 'bg-violet-600 hover:bg-violet-700 text-white'
                : ''
            }`}
          >
            {isStealthMode ? (
              <EyeOff className="h-4 w-4" />
            ) : (
              <Eye className="h-4 w-4" />
            )}
            {showLabel && (
              <span className="ml-2">
                {isStealthMode ? 'Modo Privado' : 'Modo Normal'}
              </span>
            )}
          </Button>
        </TooltipTrigger>
        <TooltipContent>
          <p>
            {isStealthMode
              ? 'Doble clic para ver temporalmente'
              : 'Activar modo privado'}
          </p>
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
}
